<template>
  <modal
    :show="show"
    modal-classes="modal-secondary training-files-modal"
    size="xl"
    @close="$emit('close')"
  >
    <template slot="header">
      <h3 class="modal-title">
        <i class="fa fa-graduation-cap text-primary mr-2"></i>
        {{ title }}
      </h3>
    </template>

    <!-- Rendered only while shown: closing the window stops a playing video. -->
    <training-files-panel
      v-if="show"
      :files="files"
      :initial-file-id="initialFileId"
      :numbered="numbered"
    />

    <template slot="footer">
      <router-link
        :to="{ name: 'Trainings' }"
        class="btn btn-link"
        @click.native="$emit('close')"
      >
        <i class="fa fa-graduation-cap mr-1"></i>
        {{ $t("TRAININGS.TAB_ALL") }}
      </router-link>
      <base-button type="secondary" @click="$emit('close')">
        {{ $t("COMMON.CLOSE") }}
      </base-button>
    </template>
  </modal>
</template>

<script>
import TrainingFilesPanel from "./TrainingFilesPanel.vue";

export default {
  name: "training-files-modal",

  components: { TrainingFilesPanel },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    files: {
      type: Array,
      default: () => [],
    },
    initialFileId: {
      type: Number,
      default: null,
    },
    numbered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
